/* global Turbo */
import { Controller } from '@hotwired/stimulus'
import { createConsumer } from '@rails/actioncable'

export default class extends Controller {
  connect() {
    this.suscribeToExcelExportsResultsChannel(this.element.dataset)
  }

  suscribeToExcelExportsResultsChannel(dataset) {
    const channel = 'ExcelExports::ResultsChannel'
    const reportId = dataset.reportId
    const userId = dataset.userId
    const params = { channel: channel, report_id: reportId, user_id: userId }
    this.channel = createConsumer().subscriptions.create(params, {
      received(data) {
        this.closeWaitDialog()
        Turbo.visit(`${data.download_path}&aws_key=${data.key}&error=${data.error || ''}`)
      },
      closeWaitDialog() {
        const waitDialogContainer = document.getElementById('wait_dialog_container')
        waitDialogContainer.innerHTML = ''
      }
    })
  }
}
